import Intro from './Intro';

export { Intro };
export default Intro;
